var _defs, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack369({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8.24,
    cy: 8,
    rx: 7,
    ry: 7.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.46,11.08V4.92h1l1.2,4.36.24.91.27-1L7.38,4.92h.9v6.16H7.64V5.93L6.17,11.08h-.6L4.1,5.84v5.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.34,11.08V4.92h1.75a3.42,3.42,0,0,1,1,.11,1.7,1.7,0,0,1,.77.54,2.88,2.88,0,0,1,.5,1A4.83,4.83,0,0,1,13.52,8a4.45,4.45,0,0,1-.31,1.77,2.17,2.17,0,0,1-.78,1,2.35,2.35,0,0,1-1.26.3Zm.67-.73h1.08a1.92,1.92,0,0,0,1-.21,1.35,1.35,0,0,0,.51-.68A4.21,4.21,0,0,0,12.83,8a3.52,3.52,0,0,0-.25-1.48,1.4,1.4,0,0,0-.66-.71,2.22,2.22,0,0,0-.85-.12H10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack369);
export default __webpack_public_path__ + "static/media/Symbol_pack_369.26aca6d5f33c3b8d070f2e73388f1cf6.svg";
export { ForwardRef as ReactComponent };